/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholder_Legal_Name_NfpInputs */

const en_placeholder_legal_name_nfp = /** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Grace Community Church Inc.`)
};

const es_placeholder_legal_name_nfp = /** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Iglesia Comunitaria Grace Inc.`)
};

const fr_placeholder_legal_name_nfp = /** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Église de la Grâce`)
};

const de_placeholder_legal_name_nfp = /** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Grace Community Church e.V.`)
};

const id_placeholder_legal_name_nfp = /** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Yayasan Cinta Anak Bangsa`)
};

/** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */
const ja_placeholder_legal_name_nfp = en_placeholder_legal_name_nfp;

/** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */
const zh_placeholder_legal_name_nfp = en_placeholder_legal_name_nfp;

/** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */
const ar_placeholder_legal_name_nfp = en_placeholder_legal_name_nfp;

/** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */
const it_placeholder_legal_name_nfp = en_placeholder_legal_name_nfp;

/** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */
const ru_placeholder_legal_name_nfp = en_placeholder_legal_name_nfp;

/** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */
const pt_placeholder_legal_name_nfp = en_placeholder_legal_name_nfp;

/** @type {(inputs: Placeholder_Legal_Name_NfpInputs) => LocalizedString} */
const ko_placeholder_legal_name_nfp = en_placeholder_legal_name_nfp;

/**
* | output |
* | --- |
* | "e.g. Grace Community Church Inc." |
*
* @param {Placeholder_Legal_Name_NfpInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const placeholder_legal_name_nfp = /** @type {((inputs?: Placeholder_Legal_Name_NfpInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholder_Legal_Name_NfpInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeholder_legal_name_nfp(inputs)
	if (locale === "es") return es_placeholder_legal_name_nfp(inputs)
	if (locale === "fr") return fr_placeholder_legal_name_nfp(inputs)
	if (locale === "de") return de_placeholder_legal_name_nfp(inputs)
	if (locale === "ja") return ja_placeholder_legal_name_nfp(inputs)
	if (locale === "zh") return zh_placeholder_legal_name_nfp(inputs)
	if (locale === "ar") return ar_placeholder_legal_name_nfp(inputs)
	if (locale === "id") return id_placeholder_legal_name_nfp(inputs)
	if (locale === "it") return it_placeholder_legal_name_nfp(inputs)
	if (locale === "ru") return ru_placeholder_legal_name_nfp(inputs)
	if (locale === "pt") return pt_placeholder_legal_name_nfp(inputs)
	return ko_placeholder_legal_name_nfp(inputs)
});